import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatPrice = (price) => {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR'
  }).format(price);
};

export const formatDate = (date, language = 'es') => {
  const locales = {
    es: 'es-ES',
    en: 'en-US',
    fr: 'fr-FR'
  };
  return new Intl.DateTimeFormat(locales[language] || 'es-ES', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(new Date(date));
};

export const getAvailableTimes = () => {
  const times = [];
  // Summer schedule: 10:00 - 22:00
  // Winter schedule: 10:00 - 19:00
  // Using broader schedule for flexibility
  for (let hour = 10; hour <= 21; hour++) {
    times.push(`${hour.toString().padStart(2, '0')}:00`);
    if (hour < 21) {
      times.push(`${hour.toString().padStart(2, '0')}:30`);
    }
  }
  return times;
};
